'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

function formatIn(value) {
  if ((0, _lodash.isEmpty)(value)) {
    return [];
  } else {
    return value.map(function (item) {
      if ((0, _lodash.isObject)(item) && !(0, _lodash.isNil)(item)) {
        return item.value;
      }
      return item;
    });
  }
}

// value为 ['1', '2', '3'] 类型的数组
// options 为未经过转换的 options
function formatOut(value, options) {
  if ((0, _lodash.isEmpty)(value)) {
    return [];
  } else if ((0, _lodash.isEmpty)(options)) {
    return value.map(function (item) {
      return {
        text: item,
        value: item
      };
    });
  } else {
    return options.filter(function (option) {
      return (0, _lodash.includes)(value, option.value);
    });
  }
}

function defaultValueFormatter(value, state, options) {
  if ((0, _lodash.isEmpty)(value)) {
    return '';
  } else {
    return value.map(function (item) {
      if ((0, _lodash.isNil)(item)) {
        return '';
      }
      if (!(0, _lodash.isEmpty)(options)) {
        var option = options.find(function (optionItem) {
          return (0, _lodash.isObject)(item) ? optionItem.value === item.value : optionItem.value === item;
        });
        if (option) {
          return option.text || option.label;
        }
      }
      if ((0, _lodash.isObject)(item)) {
        return item.text || item.value;
      }
      return item;
    }).join(',');
  }
}

function fieldDataFormatter(value, options, state) {
  if (Array.isArray(value) && !(0, _lodash.isEmpty)(value)) {
    var result = [];
    value.forEach(function (valueItem) {
      var realItem = valueItem;
      if ((0, _lodash.isObject)(valueItem)) {
        realItem = options.find(function (item) {
          return item.value === valueItem.value;
        });
      } else {
        realItem = options.find(function (item) {
          return item.value === valueItem;
        });
      }
      result.push(realItem || valueItem);
    });
    return result;
  }
  return value;
}

exports.default = {
  formatIn: formatIn,
  formatOut: formatOut,
  defaultValueFormatter: defaultValueFormatter,
  fieldDataFormatter: fieldDataFormatter
};
module.exports = exports['default'];